import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledBoxProps {
  layoutHeightLG: number;
  layoutHeightSM: number;
}

const StyledBox = styled(Box)<StyledBoxProps>(({ theme, layoutHeightLG, layoutHeightSM }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  paddingTop: `calc(${theme.spacing(layoutHeightLG)} + ${theme.spacing(15.125)})`,
  [theme.breakpoints.down('lg')]: {
    paddingTop: `calc(${theme.spacing(layoutHeightSM)} + ${theme.spacing(5)})`,
  },
  '& .HSDescription': {
    marginTop: theme.spacing(3),
    color: theme.palette.text.secondary,
    maxWidth: theme.spacing(119.652),
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(2),
    },
  },
}));

export default StyledBox;
